<script setup lang="ts">
  import HeaderUseCaseMenuMobile from '@/components/header/UseCaseMenuMobile.vue';
  import ChatInfoBar from '@/components/chat/ChatInfoBar.vue';

  const viewport = useViewport();

  const { serviceMenuItems } = await useSharedContent();
</script>

<template>
  <div class="chat-layout">
    <AppHeader :is-mobile="viewport.isLessThan('lg')">
      <template #center>
        <ChatInfoBar />
      </template>
      <template #bottom>
        <HeaderUseCaseMenuMobile :items="serviceMenuItems" />
      </template>
    </AppHeader>
    <slot />
  </div>
</template>
